<template>
  <div>
    <header class='demos-header'>
      <h1 class="demos-title">预约登记</h1>
    </header>

    <div class="weui-cells weui-cells_form">
      <form id="orderSearchForm" method="get" action="/wx/reservation/orderResult">

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="code1">编码/名称</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respAddParam.code1" v-bind:disabled="yylimit" class="weui-input" type="text" @change="changecodes" >
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="codeId1">客戶ID </label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respAddParam.codeId1"  v-bind:disabled="true" class="weui-input" type="text" >
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="name">客户：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respAddParam.name"   v-bind:disabled="true" class="weui-input" type="text" >
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="remainAmount">客户余额：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respAddParam.remainAmount"  v-bind:disabled="true" class="weui-input" type="text" >
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="level">客户等级：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respAddParam.level"   v-bind:disabled="true" class="weui-input" type="text" >
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="cond_productName">物料名称：</label>
          </div>
          <div class="weui-cell__bd">
            <select id="cond_materiel"   @change="changeMateriel" v-model="respAddParam.selectMaterielId"  class="weui-input"  required="required">
              <option value="">请选择</option>
              <option v-for="(item, index) in materList" :key="index" :value="item.id">{{ item.name }}</option>
            </select>
          </div>
        </div>


        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="materielSpec">规格：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respAddParam.materielSpec"  class="weui-input" v-bind:disabled="true" >
          </div>
        </div>


        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="mprice">单价：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respAddParam.mprice"  class="weui-input" v-bind:disabled="true" >
          </div>
        </div>

        <div class="weui-cell" v-show="false">
          <div class="weui-cell__hd">
            <label class="weui-label" for="lessquailty">剩余量(吨)：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respAddParam.lessquailty"  class="weui-input" v-bind:disabled="true">
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="vehicleNo">车号：</label>
          </div>
          <div class="weui-cell__bd">

            <a-auto-complete
              v-model="respAddParam.vehicleNo"
              class="weui-input"
              :dataSource="vehicleNoList"
              style="max-width: 150px"
              placeholder=""
              :filterOption="filterOption"
              @change="(value) => changeVehicleNo(value)"
            />

          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="driverName">司机：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respAddParam.driverName" class="weui-input" type="text" >
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="phone">手机号：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respAddParam.phone" class="weui-input" type="text" >
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="idcard">身份证号：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respAddParam.idcard" class="weui-input" type="text" >
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="cond_productName">车型：</label>
          </div>
          <div class="weui-cell__bd">
            <select id="cond_materiel"   @change="changeCarType" v-model="respAddParam.vehicleTypeId"  class="weui-input"  required="required">
              <option value="">请选择</option>
              <option v-for="(item, index) in corpVehicleTypeSelect" :key="index" :value="item.id">{{ item.name }}</option>
            </select>
          </div>
        </div>



        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="lessquailty">荷载重量：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respAddParam.maxweight"  class="weui-input" v-bind:disabled="true">
          </div>
        </div>


        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="quailty">预约量：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model.trim="respAddParam.quailty" class="weui-input" @change="changeQuailty" type="text" >
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="mprice2">货物总金额：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respAddParam.mprice2"  v-bind:disabled="true" class="weui-input" type="text" >
          </div>
        </div>



        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label">上门日期：</label>
          </div>
          <div class="weui-cell__bd">
            <a-date-picker
              :defaultValue="defaultDate"
              :disabledDate="disabledDate"
              v-model="respAddParam.appointedDate"
              style="max-width: 150px"
              placeholder="请选择日期" />
          </div>
        </div>

        <!--<div class="weui-cell" style="text-align: center">
           <a href="javascript:void(0);" :loading="loading" class="weui-btn weui-btn_primary" @click="addReservation">预约提交</a>
        </div>-->

        <div style="text-align: center">
          <a-button style="margin-bottom: 5px" type="primary" @click="addReservation" :loading="loading" >预约提交</a-button>
          <a-button style="margin-bottom: 5px;margin-left: 10px" type="primary" @click="cleanReservationInfo"  >重置</a-button>
        </div>
      </form>
    </div>

    <!--  <div class="weui-cell">
        <div class="weui-cell__bd">
          <a onclick="history.back()" class="weui-btn weui-btn_primary">返回</a>
        </div>
      </div> -->
  </div>
</template>

<script>
  import { wxButtonList } from '@/api/sys'
  import { mapActions } from 'vuex'
  import { getCorpSupplierList,selectBusinessByCode,materielPriceselectBycodelevel,findscanquery,findcarnoinfo,vehicleTypeList,selectCodeByCustomer,findCarTypeById,findcartypeinfo } from '@/api/basic'
  import { reservationAdd, baseInfoList,reservationAddMulti } from '@/api/logistics'
  import storage from "@/utils/storage"
  import weui from 'jquery-weui/dist/js/jquery-weui.min'
  import { showMsg } from '@/utils/util'
  import moment from 'moment'
  import Bus from '@/layouts/bus'
  import Vue from 'vue'
  import { findPrivileBycode,findproperties } from '@/api/sys'


  export default {
    name: 'HelloWorld',
    data() {
      return {
        loading:false,
        bizList:this.config.bizList,
        //bizList:this.$store.getters.bizList,
        selectSupplier:  {key: '', label: '请选择'},
        selectSupplierId: null,
        corpVehicleTypeSelect: null,
        selectSupplierName: '',
        selectedBizId: null,
        selectMaterielId: "",
        supplierSelect:null,
        corpSupplierId:null,
        roleId:null,
        rolelimit: false,
        yylimit: true,
        ylminmoney:0.0, //预留最小金额
        materielData:{},
        materList:[],
        vehicleNoList:[],
        respAddParam:{},

        showrArow:false,
        appointedDate: moment(new Date(), 'YYYY-MM-DD'),
        defaultDate: moment(new Date(), 'YYYY-MM-DD')

      }
    },
    created () {
      this.configParam()
      this.checkButtonPrivilege()
      this.selectedBizId = this.bizList[3].id
      this.loadBaseInfoList()
      this.roleId = this.$store.getters.roles
      // 如果登录的用户不是供应商,目前为管理员或采购员,需要选择供应商
      if (this.roleId !== this.config.RoleType.SUPPLIER){
        this.loadSupplierSelect()
      }
      this.handleBizChange(this.selectedBizId)

      new Promise(resolve => {
        const data = vehicleTypeList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.corpVehicleTypeSelect = res
      })

      this.yuyuelimit()
      //客户只读属性

    },
    methods: {
      moment,
      disabledDate(current) {

        // 设置区间之外的日期不可选
        return  current>moment().add(1, "days") || current<moment().subtract(1, "days")
      },
      configParam(){
        new Promise(resolve => {

          const data = findproperties({ key:'15' }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.ylminmoney=res.value
          console.log("最小预约金额:"+this.ylminmoney)
        })
      },
      //分配物流记录按钮权限
      checkButtonPrivilege(record) {

        new Promise(resolve => {
          const data = findPrivileBycode({ code:'dykh-handler' }).then(res => { return res.data })
          resolve(data)
        }).then(res => {

          if(res=='dykh-handler'){
            this.rolelimit=true

            console("待约客户标记true")
          }else{
            //查找客户code

            new Promise(resolve => {
              const data = selectCodeByCustomer({}).then(res => { return res.data })
              resolve(data)
            }).then(res => {


              this.customercode=res.code

              new Promise(resolve => {

                const data = selectBusinessByCode({ code: this.customercode }).then(res => { return res.data })
                resolve(data)
              }).then(res => {
                this.respAddParam.code1=res.code
                this.respAddParam.name = res.name
                this.respAddParam.remainAmount=res.remainAmount
                this.respAddParam.level=res.level
                this.respAddParam.codeId1=res.id
                this.respAddParam.quailty=null
                this.respAddParam.mprice2=null
                this.yylimit= true
              })
            })

          }
        })

      },
      moment,
      changeCarType(e){

        var materielId = this.respAddParam.vehicleTypeId
        new Promise(resolve => {

          const data = findCarTypeById({ id:materielId }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.respAddParam.quailty=null
          this.respAddParam.mprice2=null

          //this.respAddParam.maxweight = res.loadWeight
          Vue.set(this.respAddParam, 'maxweight', res.loadWeight)

        })
      },
      yuyuelimit(){
        this.yylimit= false;
      },
      changeVehicleNo(value, isUpperCase) {
        // 限制只能输入7位
        if (value.length > this.config.vehicleNoLength) {
          this.respAddParam.vehicleNo = value.substring(0, this.config.vehicleNoLength)
        }
        // 转换成大写
        if (isUpperCase === true && value.length >= 7) {
          this.respAddParam.vehicleNo = value.toUpperCase();
        }
        if(this.respAddParam.vehicleNo !='' && this.respAddParam.vehicleNo.length>3) {
          //查询车子
          new Promise(resolve => {
            const data = findscanquery({vehicleNo: this.respAddParam.vehicleNo}).then(res => {
              return res.data
            })
            resolve(data)
          }).then(res => {
            this.vehicleNoList = res

          })

          new Promise(resolve => {
            const data = findcarnoinfo({vehicleNo: this.respAddParam.vehicleNo}).then(res => {
              return res.data
            })
            resolve(data)
          }).then(res => {
            //Vue.set(this.respAddParam, 'driverName', res.dname)
            if (res == null) {

            } else {
              Vue.set(this.respAddParam, 'driverName', res.dname)
              // this.respAddParam.driverName = res.dname
              this.respAddParam.phone = res.phone
              this.respAddParam.idcard = res.idcard
              this.respAddParam.vehicleTypeId = res.vehicleTypId
              this.respAddParam.maxweight = res.loads
              this.respAddParam.maxAppoint = res.maxAppoint
            }
          })


          /*new Promise(resolve => {
           const data = findcartypeinfo({vehicleNo: this.respAddParam.vehicleNo}).then(res => {
           return res.data
           })
           resolve(data)
           }).then(res => {
           if (res == null) {

           } else {
           //Vue.set(this.respAddParam, 'vehicleTypeId.key', res.vehicleType)
           // Vue.set(this.respAddParam, 'vehicleTypeId.label', res.vname)
           Vue.set(this.respAddParam, 'maxweight', res.loadWeight)
           this.respAddParam.vehicleTypeId = res.vehicleType
           //this.respAddParam.vehicleTypeId.label=res.vname

           //this.respAddParam.maxweight=res.loadWeight
           }
           })*/
        }
      },
      changeQuailty(e){

        var code = e.target.value
        if(this.respAddParam.mprice) {
          var m = 0;
          var s1 = this.respAddParam.mprice.toString().replace(/\s*/g, '');
          var s2 = code.toString().replace(/\s*/g, '');
          try {
            m += s1.split(".")[1].length;
          } catch (e) {
          }
          try {
            m += s2.split(".")[1].length;
          } catch (e) {
          }
          var mprice2value = Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
          console.log("总价:" + mprice2value);
          // Vue.set(this.respAddParam, 'mprice2',mprice2value);
          this.respAddParam.mprice2 = Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
          var ylmoney = Number(this.respAddParam.mprice2) + Number(1500);
          if (ylmoney > this.respAddParam.remainAmount) {
            Vue.set(this.respAddParam, 'quailty', '');
            Vue.set(this.respAddParam, 'mprice2', '');
            //  this.respAddParam.quailty=''
            //  this.respAddParam.mprice2=''
            //showMsg('总金额超出余额')
            this.$message.warning('总金额超出余额', 3)
            return
          }
          if (code > this.respAddParam.lessquailty) {
            Vue.set(this.respAddParam, 'mprice2', '');
            Vue.set(this.respAddParam, 'mprice2', '');
            //  this.respAddParam.quailty=''
            // this.respAddParam.mprice2=''
            // showMsg('预约量超出剩余量')
            this.$message.warning('预约量超出剩余量', 3)
            return
          }

          if (code > this.respAddParam.maxweight) {
            Vue.set(this.respAddParam, 'mprice2', '');
            Vue.set(this.respAddParam, 'mprice2', '');
            // this.respAddParam.quailty=''
            //this.respAddParam.mprice2=''
            //showMsg('预约量超出该车型荷载量')
            this.$message.warning('预约量超出该车型荷载量', 3)
            return
          }


        }
      },
      validate () {


        var m = 0;
        var s1 = this.respAddParam.mprice.toString();
        var s2 = this.respAddParam.quailty.toString();
        try {
          m += s1.split(".")[1].length;
        } catch (e) {}
        try {
          m += s2.split(".")[1].length;
        } catch (e) {}

        var kk=Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
        // console.log("算出总金额:"+kk+",输入框金额:"+this.mprice2)
        if (kk !== this.respAddParam.mprice2){
          this.$message.warning('总金额不正确',3)
          return false
        }
        if (!this.respAddParam.selectMaterielId){
          //  showMsg('物料不能为空')
          this.$message.warning('物料不能为空',3)
          return false
        }
        if (!this.respAddParam.vehicleNo || !this.respAddParam.phone ){
          this.$message.warning('请完善预约信息',3)
          return false
          //showMsg('请完善预约信息')
          //  return false
        }

        if(this.respAddParam.quailty<=0){
          this.$message.warning('预约量不能为0', 3)
          return false
        }
        if(!this.respAddParam.vehicleTypeId||!this.respAddParam.maxweight){
          this.$message.warning('请选择车型',3)
          return false
        }

        if (!this.config.Regex.telephone.test(this.respAddParam.phone)) {
          // showMsg('手机号格式错误')
          this.$message.warning('手机号格式错误', 3)
          return
        }
        //增加校验车号
        this.respAddParam.vehicleNo=this.respAddParam.vehicleNo.trim()
        if (!this.config.Regex.vehicleNo.test(this.respAddParam.vehicleNo)) {
          this.$message.warning('车号格式错误', 3)
          return false
        }

        var today = new Date();
        var targetDate = new Date(this.respAddParam.appointedDate+" 23:59:59".replace("-", "/").replace("-", "/"));
        if (targetDate < today){
          //showMsg('上门日期不能小于当天')
          this.$message.warning('上门日期不能小于当天', 3)
          return
          return false;
        }



        return true
      },
      cleanReservationInfo(){
        console.log('AAAAAAAAAAAAAAAAA')

          this.respAddParam.materielSpec=''
          this.respAddParam.maxweight=null
          this.respAddParam.vehicleTypeId={ key: '', label: '' }
          this.respAddParam.mprice=null
          this.respAddParam.mprice2=null
          this.respAddParam.quailty=null
          this.respAddParam.selectMaterielId=null
          this.respAddParam.corpLogisticsId=null
          this.respAddParam.vehicleNo=''
          this.respAddParam.driverName=''
          this.respAddParam.phone=''
          this.respAddParam.idcard=''
          this.$forceUpdate
      },
      addReservation () {
        if (!this.validate()){
          return
        }
        if(this.quailty && this.maxAppoint){
          if(this.quailty > this.maxAppoint){
            this.$message.warning('预约量超过该车设置的最大预约量:'+'该车最大预约量'+this.maxAppoint)
            return
          }
        }
        const _this = this
        _this.loading = true
        //提交日期 做格式转换
        if(!this.respAddParam.appointedDate){
          this.respAddParam.appointedDate=moment(new Date()).format("YYYY-MM-DD");
        }else{
          this.respAddParam.appointedDate=moment(this.respAddParam.appointedDate).format("YYYY-MM-DD");
        }
        let obj = {'maxweight':this.respAddParam.maxweight,'vehicleTypeId':this.respAddParam.vehicleTypeId,'mprice':this.respAddParam.mprice,'mprice2':this.respAddParam.mprice2,'predictQuantity':this.respAddParam.quailty,'materielMultiParam':this.respAddParam.selectMaterielId, 'businessTypeId':101, 'corpSupplierId':this.respAddParam.codeId1, 'corpBusinessId':this.respAddParam.codeId1, 'corpLogisticsId':this.respAddParam.corpLogisticsId, 'vehicleNo':this.respAddParam.vehicleNo, 'driverName':this.respAddParam.driverName, 'phone':this.respAddParam.phone, 'idcard':this.respAddParam.idcard, 'appointedDate':this.respAddParam.appointedDate,'hasOrder':this.respAddParam.hasOrder}
        Bus.$emit('showSpinning', true, "提交中...")
        reservationAddMulti(obj)
          .then(res => {
            if (res.code === '0') {
              //showMsg('提交成功')
              this.$message.warning('提交成功', 3)
              this.$router.push({ name: 'wxRespList' })
            }
          }).catch((e) => {
          console.log(e)
        }).finally(() => {
          _this.loading = false
          Bus.$emit('showSpinning', false)
        })
      },
      filterOption (input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      loadSupplierSelect () {
        new Promise(resolve => {
          const data = getCorpSupplierList({ }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.supplierSelect = res
          this.supplierSelect.unshift({"id":"","name":"请选择"})
        })
      },

      changeMateriel(e) {
        let that=this
        that.respAddParam.selectMaterielName = e.label

        var materielId = that.respAddParam.selectMaterielId
        console.log("本次物料id:"+materielId);
        var levels=null
        if(that.respAddParam.level==="A"){
          levels=1
        }else  if(that.respAddParam.level==="B"){
          levels=2
        }else  if(that.respAddParam.level==="C"){
          levels=3
        }else  if(that.respAddParam.level==="D"){
          levels=4
        }
        new Promise(resolve => {
          const data = materielPriceselectBycodelevel({ materielId: materielId, customerLevel: levels }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          Vue.set(that.respAddParam, 'mprice', res.price)

          Vue.set(that.respAddParam, 'lessquailty', res.remainQuality)
          Vue.set(that.respAddParam, 'materielSpec', res.materielSpec)

          that.respAddParam.quailty=null
          that.respAddParam.mprice2=null
        })

      },

      changecodes(e){

        var code = e.target.value
        new Promise(resolve => {
          const data = selectBusinessByCode({ code:code }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          console.log(res.name)
          Vue.set(this.respAddParam, 'name', res.name)
          // this.respAddParam.name = res.name
          this.respAddParam.remainAmount=res.remainAmount
          this.respAddParam.level=res.level
          this.respAddParam.codeId1=res.id
          this.respAddParam.quailty=null
          this.respAddParam.mprice2=null
        })
      },


      handleBizChange(value, e) {
        value = value || e.target.value;
        this.materList = this.materielData[value]
        this.respAddParam.materielType = value

        let obj = this.bizList.find((item)=>{
          return item.id === value;
        });
        this.respAddParam.materielType = obj.name
      },

      loadBaseInfoList () { // 从后台拉去下拉列表数据
        new Promise(resolve => {
          const data = baseInfoList({ }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.materielList = res.materielList

          for (var i = 0; i < this.materielList.length; i++){
            let materie = this.materielList[i]
            if ( !(this.materielData[materie.businessTypeId] instanceof Array) ){
              this.materielData[materie.businessTypeId] = []
            }
            this.materielData[materie.businessTypeId].push(materie)
          }
          this.materList = this.materielData[this.selectedBizId]

          this.handleBizChange(this.selectedBizId)
        })
      },
      toReservation() {
        if (this.roleId !== this.config.RoleType.SUPPLIER){
          if (!this.selectSupplierId){
            // showMsg("请选择供应商");

            this.$message.warning('请选择供应商', 3)
            return
          }
          this.respAddParam.supplierName = this.selectSupplierName;
          this.respAddParam.corpSupplierId = this.selectSupplierId;
        }
        if (!this.selectMaterielId){
          // showMsg("请选择物料");
          this.$message.warning('请选择物料', 3)
          return
        }
        let materielName = $("#cond_materiel option:selected").text();
        this.respAddParam.materielName = materielName;
        this.respAddParam.materielId = this.selectMaterielId;
        this.respAddParam.businessTypeId = this.selectedBizId;
        storage.save("cache-respAddParam", JSON.stringify(this.respAddParam));
        this.$router.push({ name: 'wxRespAddDetails' })
      },
      changeSupplier(e) {
        this.selectSupplierId = e.key
        this.selectSupplierName = e.label
        this.selectSupplier =  {key: e.key.toString(), label: e.label}
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /deep/ .ant-select-selection {
    border:0px;
    font-size: 16px;
    margin-left: -10px;
    height: 1.47058824em;
    line-height: 1.47058824
  }

  /deep/ .ant-select-selection__placeholder{
           font-size: 16px;
           color:inherit;
         }

</style>